/* Han nav.js layout mathematics, adapted only at Shopify DOM boundaries.
   Shopify continues to own menus, search, account and cart behaviour. */
(() => {
  'use strict';
  if (!document.body.hasAttribute('data-han-story-page')) return;
  const cleanups = new Map();
  function initialize() {
  const header = document.querySelector('.shopify-section-header');
  if (!header || cleanups.has(header)) return;
  const controller = new AbortController(), signal = controller.signal;
  const hero = document.querySelector('[data-han-story-source] .about-hero'); // Story pages overlay their hero; collection pages remain compact.
  const mobile = matchMedia('(max-width:767px)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const colourLink = header.querySelector('.header__inline-menu a[href*="find-your-everyday"]')?.closest('.list-menu-item');
  colourLink?.classList.add('han-home-colour-link');
  const art = header.querySelector('.han-logo-art');
  if (art && !art.querySelector('.han-home-logo-wordmark')) {
    const wordmark = document.createElement('span'); wordmark.className = 'han-home-logo-wordmark';
    while (art.firstChild) wordmark.append(art.firstChild);
    const location = wordmark.cloneNode(true); location.className = 'han-home-logo-location';
    location.setAttribute('aria-hidden','true'); location.querySelectorAll('img').forEach(img=>img.alt='');
    art.append(wordmark,location);
  }
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const lerp = (a, b, p) => a + (b - a) * p;
  // Match the shared --ease-motion cubic-bezier(.16,1,.3,1) on timed channels.
  const easeMotion = progress => {
    const x = clamp(progress);
    if (x === 0 || x === 1) return x;
    let lower = 0;
    let upper = 1;
    let position = x;
    for (let i = 0; i < 20; i++) {
      const inverse = 1 - position;
      const curveX = 3 * .16 * inverse * inverse * position + 3 * .3 * inverse * position * position + position * position * position;
      if (curveX < x) lower = position;
      else upper = position;
      position = (lower + upper) / 2;
    }
    return 1 - Math.pow(1 - position, 3);
  };

  let progress=0, menuProgress=0, announcementProgress=0, isOpen=false;
  let announcementDismissed=false, raf=0, width=innerWidth, pad=width*.021, panelHeight=0, compactByScroll=false;
  const channels = {
    layout:{value:0,target:0,duration:660,active:false},
    panel:{value:0,target:0,duration:650,active:false},
    announcement:{value:0,target:0,duration:380,active:false}
  };
  function targetProgress(){return isOpen || compactByScroll ? 1 : 0;}
  function draw() {
    progress = channels.layout.value;
    menuProgress = channels.panel.value;
    announcementProgress = channels.announcement.value;
    const p = progress;
    const large = width >= 2000;
    const announceHeight = mobile.matches ? 27 : large ? 30 : 22;
    const originalHeight = mobile.matches ? 64 : large ? 103 : 78;
    const finalHeight = mobile.matches ? 64 : large ? 72 : 62;
    const logoWidth = large ? 120 : 89;
    const logoFrameHeight = mobile.matches ? 30 : large ? 41 : 31;
    const initialLogoWidth = mobile.matches ? 87 : logoWidth;
    const visualLogoWidth = mobile.matches ? initialLogoWidth : lerp(logoWidth, large ? 104 : 78, p);
    const initialLogoInset = (logoFrameHeight - initialLogoWidth * 340 / 1100) / 2;
    const wordmarkInset = (logoFrameHeight - visualLogoWidth * 221 / 1100) / 2;
    const logoArtY = mobile.matches ? initialLogoInset : lerp(initialLogoInset, wordmarkInset, p);
    const announce = announceHeight * (1 - p) * (1 - announcementProgress);
    const color = Math.round(lerp(255, 20, clamp((p - .08) / .55)));
    const css = document.body.style;
    css.setProperty('--st-progress', p.toFixed(4));
    css.setProperty('--st-announce', `${announce.toFixed(2)}px`);
    css.setProperty('--st-bar-height', `${lerp(originalHeight, finalHeight, p).toFixed(2)}px`);
    css.setProperty('--st-menu-progress', menuProgress.toFixed(4));
    css.setProperty('--st-panel-height', `${(panelHeight * menuProgress).toFixed(2)}px`);
    css.setProperty('--st-frost', (p * .8).toFixed(4));
    css.setProperty('--st-blur', `${(p * 18).toFixed(2)}px`);
    css.setProperty('--st-ink', `${color},${color},${color}`);
    css.setProperty('--st-logo-dark', clamp((p - .12) / .48).toFixed(4));
    css.setProperty('--st-logo-width', `${visualLogoWidth.toFixed(2)}px`);
    css.setProperty('--st-logo-art-y', `${logoArtY.toFixed(2)}px`);
    css.setProperty('--st-logo-location-opacity', mobile.matches ? '1' : (1 - clamp(p / .7)).toFixed(4));
    css.setProperty('--st-logo-x', `${lerp(width * .5, pad + logoWidth / 2, p).toFixed(2)}px`);
    css.setProperty('--st-logo-y', `${lerp(large ? 23 : 16, large ? 16 : 15.5, p).toFixed(2)}px`);
    css.setProperty('--st-links-x', `${lerp(width * .5, width * .46, p).toFixed(2)}px`);
    css.setProperty('--st-links-y', `${lerp(large ? 88 : 65, finalHeight / 2, p).toFixed(2)}px`);
    css.setProperty('--st-tools-y', `${lerp(large ? 41 : 30, finalHeight / 2, p).toFixed(2)}px`);
    css.setProperty('--st-search-x', `${lerp(pad + 8, width - pad - (large ? 136 : 109), p).toFixed(2)}px`);
    header.classList.toggle('is-compact', p > .56);
    header.classList.toggle('is-scrolled', p > .01);
    header.classList.toggle('is-menu-visible', isOpen || menuProgress > 0);
    document.body.classList.toggle('han-nav-compact', p > .56);
    document.body.classList.toggle('han-menu-open', isOpen);
    if (colourLink) {
      const visible = !mobile.matches && width > 1050 && (p > .56 || isOpen);
      colourLink.inert = !visible;
      colourLink.setAttribute('aria-hidden', String(!visible));
    }
  }

  function moveChannel(channel, target) {
    if (channel.target === target && !(reduced.matches && channel.active)) return;
    channel.from = channel.value;
    channel.target = target;
    channel.started = performance.now();
    channel.active = !reduced.matches && channel.value !== target;
    if (!channel.active) channel.value = target;
  }

  function tick(time) {
    Object.values(channels).forEach(channel => {
      if (!channel.active) return;
      const elapsed = clamp((time - channel.started) / channel.duration);
      const eased = easeMotion(elapsed);
      channel.value = lerp(channel.from, channel.target, eased);
      if (elapsed === 1) {
        channel.value = channel.target;
        channel.active = false;
      }
    });
    draw();
    if (Object.values(channels).some(channel => channel.active)) raf = requestAnimationFrame(tick);
    else raf = 0;
  }

  function update() {
    moveChannel(channels.layout, targetProgress());
    moveChannel(channels.panel, isOpen ? 1 : 0);
    moveChannel(channels.announcement, announcementDismissed ? 1 : 0);
    draw();
    if (!raf && Object.values(channels).some(channel => channel.active)) raf = requestAnimationFrame(tick);
  }


  function synchronize(initial=false){
    width=innerWidth; pad=mobile.matches?18:width*.021;
    const threshold=hero?hero.offsetTop+hero.offsetHeight*.8:0;
    if(initial)compactByScroll=scrollY>=threshold;
    else if(!compactByScroll && scrollY>=threshold)compactByScroll=true;
    else if(compactByScroll && scrollY<threshold-24)compactByScroll=false;
    isOpen=!!header.querySelector('.burger-menu--open,.menu-drawer-container[open],.han-content-menu[open]');
    const announcement=document.querySelector('.section-announcement');
    announcementDismissed=!!announcement && (announcement.hidden || getComputedStyle(announcement).display==='none');
    panelHeight=header.querySelector('.burger-menu__dropdown-wrapper')?.offsetHeight || 0;
    if(initial)channels.layout.value=channels.layout.target=targetProgress();
    update();
  }
  // Observe only native state attributes, never the animated inline properties.
  const observer=new MutationObserver(()=>synchronize());
  header.querySelectorAll('burger-menu,.menu-drawer-container,.han-content-menu').forEach(menu=>observer.observe(menu,{subtree:true,attributes:true,attributeFilter:['class','open','hidden']}));
  addEventListener('scroll',()=>synchronize(),{passive:true,signal});
  addEventListener('resize',()=>synchronize(),{passive:true,signal});
  reduced.addEventListener('change',()=>synchronize(),{signal});
  header.querySelectorAll('burger-menu').forEach(menu=>{
    const trigger=menu.querySelector('.burger-menu__hover--open-btn,.burger-menu__toggle--open-btn');
    if(!trigger)return;
    trigger.addEventListener('keydown',event=>{
      if(event.key!=='ArrowDown')return;
      event.preventDefault();menu.open?.(event);
      requestAnimationFrame(()=>[...menu.querySelectorAll('.burger-menu__wrapper a[href],.burger-menu__wrapper button')].find(el=>el.getClientRects().length)?.focus());
    },{signal});
    menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.close?.(event);trigger.focus()}},{signal});
  });
  if(hero){const announcement=document.querySelector('.section-announcement');if(announcement)observer.observe(announcement,{attributes:true,attributeFilter:['style','hidden']});}
  const resize=new ResizeObserver(()=>synchronize()); if(hero)resize.observe(hero);
  synchronize(true);
  const arrival = false ? header.querySelector('.header')?.animate([{opacity:0,transform:'translateY(-12px)'},{opacity:1,transform:'translateY(0)'}],{duration:900,easing:'cubic-bezier(.16,1,.3,1)'}) : null;
  cleanups.set(header,()=>{controller.abort();observer.disconnect();resize.disconnect();cancelAnimationFrame(raf);arrival?.cancel()});
  }
  initialize();
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('shopify:section:unload',event=>{cleanups.forEach((cleanup,element)=>{if(event.target.contains(element)){cleanup();cleanups.delete(element)}})});
})();
